export { PLUGIN_KEY, BasePlugin } from "./base.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/base/index.mjs
// module id = 55
// module chunks = 1